<div class="cell-content">
    @if (column.type === ColumnType.Date || column.type === ColumnType.DateAndTime) {
        <span [title]="column.cell(row)">{{ column.cell(row) | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
    } @else if (column.type === ColumnType.Boolean) {
        <span [title]="column.cell(row)">
            @if (column.cell(row) === 'true') {
                <mat-icon class="">done</mat-icon>
            }
        </span>
    } @else if (column.type === ColumnType.Link) {
        <span>
            <a href="{{ column.cell(row) | avmLink: 'Url' }}">{{ column.cell(row) | avmLink: 'DisplayName' }}</a>
        </span>
    } @else if (column.type === ColumnType.AutocompletionByApi) {
        <span>TODO : Affichage d'un attribut de type Autocompletion par API</span>
    } @else {
        <span [title]="column.cell(row)" [ngClass]="column.columnName === 'message' && column.cell(row).length > 250 ? 'message-content' : ''">
            @if (column.columnName === 'defaultValueDisplayed' && row.type === PropertyType.Color) {
                <div class="color-indicator bak-{{ column.cell(row) }}-color">
                    @if (column.cell(row) === '') {
                        <span>Aucune</span>
                    }
                </div>
            }
            @if (column.columnName !== 'defaultValueDisplayed' || (column.columnName === 'defaultValueDisplayed' && row.type !== PropertyType.Color)) {
                <div
                    [ngClass]="{
                        'undeveloped-message-content': column.columnName === 'message' && column.cell(row).length > 250 && !isDeveloped,
                        'message-cell': column.columnName === 'message' && column.cell(row).length > 250,
                    }">
                    {{ column.cell(row) }}
                </div>
            }
            @if (column.columnName === 'message' && column.cell(row).length > 250) {
                <button mat-icon-button (click)="toggleDevelop()">
                    @if (isDeveloped) {
                        <mat-icon>remove_circle</mat-icon>
                    } @else {
                        <mat-icon>add_circle</mat-icon>
                    }
                </button>
            }
        </span>
    }
</div>
